import { render, staticRenderFns } from "./ModalInfoUnpaidRemindedInvoices.vue?vue&type=template&id=00a15f40&scoped=true&"
import script from "./ModalInfoUnpaidRemindedInvoices.vue?vue&type=script&lang=js&"
export * from "./ModalInfoUnpaidRemindedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoUnpaidRemindedInvoices.vue?vue&type=style&index=0&id=00a15f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a15f40",
  null
  
)

export default component.exports